// extracted by mini-css-extract-plugin
export var arrowIcon = "ctaButton-module--arrowIcon--2fd0b";
export var button = "ctaButton-module--button--a1fd1";
export var full = "ctaButton-module--full--a646e";
export var hasIcon = "ctaButton-module--hasIcon--bb03b";
export var link = "ctaButton-module--link--4e713";
export var outline = "ctaButton-module--outline--c4ea6";
export var v1 = "ctaButton-module--v1--5410d";
export var v2 = "ctaButton-module--v2--5c96f";